export default __webpack_public_path__ + "media/images/logo-11cd634bc6a71f0384d5891a3f744c83.svg";